export default ({ instance }) => {
	return {
		autenticarEmailChave(dados) {
			return instance({
				method: "post",
				url: "multifator/autenticar-email-chave",
				data: dados,
			});
		},
		
		gerarNovaChave(email) {
			return instance({
				method: "post",
				url: "multifator/gerar-nova-chave",
				data: { "email": email },
			});
		},

		alterarUsoMFA(dados) {
			return instance({
				method: "post",
				url: "multifator/alterar-uso-mfa",
				data: { "email": dados.usuario, "usaMFA": dados.usaMFA },
			});
		},
	};
};
